import FastImage from 'react-native-fast-image';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Modal from 'react-native-modal';

export const Container = styled(Modal)`
  justify-content: flex-end;
  margin: 0;
`;
export const BuyAgainContainer = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const BuyAgainContent = styled.View`
  flex-direction: row;
  flex: 1;
  align-items: center;
`;

export const BuyAgainImage = styled(FastImage)`
  height: ${RFValue(40)}px;
  width: ${RFValue(40)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(12)}px;
`;

export const BuyAgainInfos = styled.View`
  margin-left: ${RFValue(8)}px;
  flex: 1;
`;

export const LinkButtonContainer = styled.View`
  flex-direction: row;
`;

export const BuyAgainRegion = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;
export const BuyAgainName = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;

  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const BuyAgainPriceContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const BuyAgainPrice = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;

  margin-right: ${RFValue(4)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const RankBadge = styled(FastImage)`
  width: ${RFValue(24)}px;
  height: ${RFValue(24)}px;
`;

export const ModalTitle = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;

  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const ModalFooter = styled.View`
  margin-top: ${RFValue(12)}px;
  width: 100%;
`;

export const ModalHeader = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;
export const ModalContent = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  padding: ${RFValue(18)}px ${RFValue(24)}px;
  padding-bottom: ${RFValue(18)}px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

export const BuyAgainList = styled.View`
  margin-top: ${RFValue(12)}px;
  padding-top: ${RFValue(12)}px;
  border-style: solid;
  border-top-width: 1px;
  border-color: ${({theme}) => theme.colors.border};

  margin-bottom: ${RFValue(12)}px;
  padding-bottom: ${RFValue(6)}px;
  border-style: solid;
  border-bottom-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
`;

export const BuyAgainListItem = styled.View`
  margin-bottom: ${RFValue(6)}px;
`;

export const BuyAgainListItemTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const BuyAgainListItemText = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const BuyAgainTotalContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const BuyAgainTotalTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const BuyAgainTotalText = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const BuyAgainButton = styled.TouchableOpacity`
  height: ${RFValue(22)}px;
  border-radius: ${RFValue(8)}px;
  justify-content: center;
  padding: 0 ${RFValue(14)}px;
  align-items: center;
  background-color: ${({theme}) => theme.colors.black};
  border: 1px solid ${({theme}) => theme.colors.black};
`;

export const BuyAgainButtonText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.bold};
`;
